import fetch from '@adc/fetch';
import { embeddableOperation } from './utils';
const SAVE = 'save';
const UNSAVE = 'unsave';
class SavePropertyError extends Error {
}
export const saveProperty = propertyId => fetch
    .forAuctionGraph({
    query: `
      mutation ${embeddableOperation('toolkitCore_saveProperty')}($input: SavePropertyInput!) {
        saveProperty(input: $input)
      }
    `,
    variables: {
        input: { property_id: propertyId },
    },
})
    .then(res => {
    if (res.body.errors) {
        throw new SavePropertyError();
    }
    return { action: SAVE, status: 'success' };
});
export const deleteSavedProperty = propertyId => fetch
    .forAuctionGraph({
    query: `
      mutation ${embeddableOperation('toolkitCore_deleteSavedProperty')}($input: DeleteSavedPropertyInput!) {
        deleteSavedProperty(input: $input)
      }
    `,
    variables: {
        input: { property_id: propertyId },
    },
})
    .then(res => {
    if (res.body.errors) {
        throw new SavePropertyError();
    }
    return { action: UNSAVE, status: 'success' };
});
//# sourceMappingURL=savePropertyProvider.js.map